<template>
  <notifications position="top center" :max="5" />
  <template v-if="!loading && isAuthenticated && checkedUserMode">
    <div class="h-full">
      <div class="wrap-content flex flex-col h-full">
        <div class="h-12 shadow-md z-50 hidden sm:block">
          <div class="flex justify-between">
            <div id="content" class="ml-3 flex flex-wrap content-center">
              <router-link :to="{ name: 'DriverMode' }" class="py-2">
                <img
                  class="h-8 w-8"
                  src="/images/favicons/favicon-32x32.png"
                  alt="Workflow"
                />
              </router-link>
            </div>
            <div class="pr-3 flex flex-wrap content-center justify-end">
              <div class="pr-3 flex items-center justify-center">
                <div
                  style="max-width: 12rem"
                  class="text-sm flex flex-col justify-center"
                >
                  <div class="truncate">
                    {{ myOfficeName }}
                  </div>
                  <div class="truncate">
                    {{ user?.email }}
                  </div>
                </div>
              </div>
              <div>
                <button @click="togglePopup()" data-test="right-menu-toggle">
                  <v-icon
                    icon="account_circle"
                    :outlined="true"
                    class="text-3xl inline-block align-top"
                  />
                </button>
                <div
                  v-if="isPopupShow"
                  id="account_menu"
                  class="absolute right-0 bg-white border-2 rounded-md py-1 px-2"
                >
                  <div
                    class="cursor-pointer flex"
                    @click="logoutAndRedirect()"
                    data-test="logout-btn"
                  >
                    <v-icon icon="logout" class="text-lg" />
                    <div class="pl-2 pt-0.5">
                      {{ $t('pages.mainTemplate.logoutBtn') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="h-12 shadow-md z-50 sm:hidden">
          <div class="flex justify-between">
            <div id="mobile-content" class="ml-3 flex flex-wrap content-center">
              <router-link
                :to="{ name: 'DriverMode' }"
                class="pointer-events-auto"
              >
                <img src="/images/favicons/favicon-32x32.png" alt="Workflow" />
              </router-link>
            </div>
            <div class="h-12 pr-3 flex flex-wrap content-center">
              <div>
                <button @click="togglePopup()">
                  <v-icon
                    icon="account_circle"
                    :outlined="true"
                    class="text-3xl inline-block align-top"
                  />
                </button>
                <div
                  v-if="isPopupShow"
                  id="account_menu"
                  class="absolute right-0 bg-white border-2 rounded-md py-1 px-2 text-sm"
                >
                  <div
                    class="pt-1 pl-5 pb-2 border-b-2 border-gray-300 truncate"
                  >
                    <div class="w-40">
                      <div class="truncate">
                        {{ myOfficeName }}
                      </div>
                      <div class="truncate">
                        {{ user?.email }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      class="cursor-pointer flex pt-1.5 pb-1"
                      @click="logoutAndRedirect()"
                    >
                      <v-icon icon="logout" class="text-base" />
                      <div class="pl-1 pt-0.5">
                        {{ $t('pages.mainTemplate.logoutBtn') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <router-view />
      </div>
    </div>
  </template>
  <template v-else>
    <div
      class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
    >
      <div class="max-w-md w-full space-y-8">
        <v-loader-animation
          :text="'text-black'"
          :loading-text-style="'text-black text-lg'"
          :loading-text="$t('common.loadingText')"
        />
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
import VIcon from '@/components/template/v-icon.vue'
import { useAuth } from '@/services/user/Auth0UserProvider'
import VLoaderAnimation from '@/components/template/v-loader-animation.vue'
import { redirectDriverMode } from '@/routes/index'
import { onMounted, ref } from 'vue'
import Api from '@/services/api/ApiServiceFabrick'
import useLogout from '@/composables/useLogout'

const { isAuthenticated, loading, user } = useAuth()
const { logoutAndRedirect } = useLogout()
const myOfficeName = ref('')
const checkedUserMode = ref(false)

let isPopupShow = ref(false)
let popupCnt = 0

onMounted(async () => {
  const isRedirected = await redirectDriverMode()
  checkedUserMode.value = !isRedirected
  if (isRedirected) return

  Api()
    .getMyOffice()
    .then((res) => {
      myOfficeName.value = res?.name ?? ''
    })
})

const hidePopup = () => {
  isPopupShow.value = false
  document.removeEventListener('click', popupEvent)
  popupCnt = 0
}

const popupEvent = (e: Event) => {
  const targets = document.querySelectorAll('.alert-notification')
  const arr = Array.prototype.slice.call(targets)
  if (
    isPopupShow.value &&
    e.target != document.getElementById('account_menu') &&
    arr.indexOf(e.target) == -1
  ) {
    if (popupCnt != 0) {
      togglePopup()
    } else {
      popupCnt++
    }
  }
}

const togglePopup = () => {
  if (!isPopupShow.value) {
    isPopupShow.value = true
    document.addEventListener('click', popupEvent)
  } else {
    hidePopup()
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
}
.bg-stone-400 {
  background-color: rgb(209 213 219);
}
.sr-only:checked ~ .bg-stone-400 {
  background-color: #3ec377;
}
/* Toggle A */
.sr-only:checked ~ .dot {
  transform: translateX(100%);
}

/* Toggle B */
.sr-only:checked ~ .dot {
  transform: translateX(100%);
}
</style>
<style scoped>
.header-blank {
  margin-left: 2rem;
}

@media (max-width: 400px) {
  .header-blank {
    margin-left: 1rem;
  }
}
</style>
